import React from 'react';
import { FaPlay } from 'react-icons/fa';
import CardItem from '../CardItem/CardItem';
import BaseCarousel from '../BaseCarousel/BaseCarousel';
import './MovieCarousel.css';

const MovieCarousel = ({ title, contents }) => {
  const renderItem = (content, handleClick) => (
    <div
      key={content.contentId}
      className={`movie-carousel-item status-${content.status}`}
      onClick={() => handleClick(content)}
      style={{
        cursor: content.status !== 'blocked' ? 'pointer' : 'not-allowed',
        opacity: content.status !== 'blocked' ? 1 : 0.5,
      }}
    >
      <CardItem
        status={content.status}
        imageUrl={content.thumbnailUrl}
        onClick={() => handleClick(content)}
      />
      <div className="movie-carousel-overlay">
        <FaPlay className="movie-carousel-item-icon" />
        <h3 className="movie-carousel-title">{content.title}</h3>
        <p className="movie-carousel-subtitle">{content.description}</p>
      </div>
    </div>
  );

  return <BaseCarousel title={title} contents={contents} renderItem={renderItem} />;
};

export default MovieCarousel;
